import React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import '../../components/Advance-Search/searchFilter.css';

export default function SearchFilter(props) {

    const handleChange = (event) => {
        props.serachFilter(event.target.value)
    }

    return (
        <FormControl>
            <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                onChange={(event) => handleChange(event)}
                defaultValue={'startwith'}
            >
                <div xs="12"> 
                <FormControlLabel value="startwith" control={<Radio />} label="Begins with" style={{marginTop:"5px",}}/>
                </div>
                <div xs="12">
                <FormControlLabel value="contains" control={<Radio />} label="Contains" style={{marginTop:"5px",}}/>
                </div>
                <div xs="12">
                <FormControlLabel value="endwith" control={<Radio />} label="Ends with" style={{marginTop:"5px",}}/>
                </div>
            </RadioGroup>
        </FormControl>
    );
}
